export default function GPSummaryLoading() {
  return (
    <div className="px-4 pt-8 grid grid-cols-1 gap-4">
      {/* Patient Info skeleton */}
      <div className="bg-white rounded-2xl border border-stone-100 shadow-sm p-5">
        <div className="h-3 w-32 bg-stone-200 animate-pulse rounded mb-4" />
        <div className="h-5 w-40 bg-stone-200 animate-pulse rounded mb-1" />
        <div className="h-3 w-32 bg-stone-100 animate-pulse rounded mb-4" />
        <div className="space-y-3">
          {[1, 2].map((i) => (
            <div key={i} className="flex justify-between">
              <div className="h-3 w-24 bg-stone-200 animate-pulse rounded" />
              <div className="h-3 w-28 bg-stone-200 animate-pulse rounded" />
            </div>
          ))}
        </div>
        <div className="border-t border-stone-100 my-3" />
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={`a${i}`} className="flex justify-between">
              <div className="h-3 w-28 bg-stone-200 animate-pulse rounded" />
              <div className="h-3 w-24 bg-stone-200 animate-pulse rounded" />
            </div>
          ))}
        </div>
      </div>

      {/* Snapshot skeleton (3x2 grid) */}
      <div className="bg-white rounded-2xl border border-stone-100 shadow-sm p-5">
        <div className="h-3 w-24 bg-stone-200 animate-pulse rounded mb-4" />
        <div className="grid grid-cols-2 gap-3">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="rounded-xl bg-stone-50 p-3.5">
              <div className="h-2.5 w-14 bg-stone-200 animate-pulse rounded mb-2" />
              <div className="h-5 w-16 bg-stone-200 animate-pulse rounded mb-1" />
              <div className="h-2.5 w-12 bg-stone-100 animate-pulse rounded" />
            </div>
          ))}
        </div>
      </div>

      {/* Card skeletons */}
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="bg-white rounded-2xl border border-stone-100 shadow-sm p-5">
          <div className="h-3 w-32 bg-stone-200 animate-pulse rounded mb-4" />
          <div className="space-y-3">
            <div className="h-10 bg-stone-100 animate-pulse rounded-lg" />
            <div className="h-10 bg-stone-100 animate-pulse rounded-lg" />
            <div className="h-6 w-3/4 bg-stone-100 animate-pulse rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}
